import React, { useRef, useState } from 'react';

// Geburtsdatum als TT / MM / JJJJ statt Kalender: tippen geht schneller als
// im Picker 16 Jahre zurückzublättern. Nur echte Daten (kein 31.02.), nicht
// in der Zukunft – dieselbe Regel prüft das Backend (isValidBirthDate).
export const toIsoDate = (d, m, y) => {
  if (!/^\d{1,2}$/.test(d) || !/^\d{1,2}$/.test(m) || !/^\d{4}$/.test(y)) return null;
  const iso = `${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`;
  const date = new Date(`${iso}T00:00:00Z`);
  if (Number.isNaN(date.getTime()) || date.toISOString().slice(0, 10) !== iso) return null;
  if (Number(y) < 1900 || date > new Date()) return null;
  return iso;
};

const PARTS = [
  { key: 'd', len: 2, placeholder: 'TT', label: 'Tag', autoComplete: 'bday-day' },
  { key: 'm', len: 2, placeholder: 'MM', label: 'Monat', autoComplete: 'bday-month' },
  { key: 'y', len: 4, placeholder: 'JJJJ', label: 'Jahr', autoComplete: 'bday-year' },
];

const fromIso = (iso) => {
  const [y = '', m = '', d = ''] = /^\d{4}-\d{2}-\d{2}$/.test(iso || '') ? iso.split('-') : [];
  return { d, m, y };
};

// onChange(value): '' = leer, ISO-Datum = gültig, null = unvollständig/ungültig
export default function BirthDateInput({ value, onChange }) {
  const [parts, setParts] = useState(() => fromIso(value));
  const refs = [useRef(null), useRef(null), useRef(null)];

  const update = (i, raw) => {
    const { key, len } = PARTS[i];
    const next = { ...parts, [key]: raw.replace(/\D/g, '').slice(0, len) };
    setParts(next);
    onChange(next.d || next.m || next.y ? toIsoDate(next.d, next.m, next.y) : '');
    if (next[key].length === len && i < PARTS.length - 1) refs[i + 1].current?.focus();
  };

  const handleKeyDown = (i, e) => {
    if (e.key === 'Backspace' && parts[PARTS[i].key] === '' && i > 0) {
      e.preventDefault();
      refs[i - 1].current?.focus();
    }
  };

  const complete = parts.d && parts.m && parts.y.length === 4;
  const invalid = complete && !toIsoDate(parts.d, parts.m, parts.y);

  return (
    <>
      <div className="birthdate-input" role="group" aria-label="Geburtsdatum">
        {PARTS.map((p, i) => (
          <React.Fragment key={p.key}>
            {i > 0 && <span className="birthdate-input__sep">/</span>}
            <input
              ref={refs[i]}
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              autoComplete={p.autoComplete}
              maxLength={p.len}
              placeholder={p.placeholder}
              aria-label={p.label}
              aria-invalid={invalid || undefined}
              className={`birthdate-input__${p.key}`}
              value={parts[p.key]}
              onChange={e => update(i, e.target.value)}
              onKeyDown={e => handleKeyDown(i, e)}
            />
          </React.Fragment>
        ))}
      </div>
      {invalid && <p className="setup-hint setup-hint--error">Dieses Datum gibt es nicht.</p>}
    </>
  );
}
